const initialState = {
    patientDataPermissions:{},
    patientDataLists: [],
    patientDataStatus: [],
    changedPatientDataStatus : [],
    loadingPatientData: false,
    errorsPatientData: {},
    patientDataListID:[],
    patientupdated:"",
    message:"",
}

const  policyDataReducer = (state = initialState, action) => {
    switch (action.type) {
        case "GET_PATIENTDATA_LIST_PENDING":
        case "ADD_PATIENTDATA_PENDING":
        case "ADD_PATIENTBASICINFO_PENDING":    
        case "UPDATE_PATIENTDATA_PENDING":
        case "UPDATE_PATIENTDATA_STATUS_PENDING":
        case "DELETE_PATIENTDATA_PENDING":
        case "DELETE_PATIENTPOLICYALERT_PENDING":
        case "GET_PATIENTDATA_LISTBYID_PENDING":
        case "DELETE_PATIENTBASICINFO_PENDING":
            return { ...state, loadingPatientData: true , errorsPatientData:{}};

        case "GET_PATIENTDATA_LIST_FULFILLED":
            return {
                ...state,
                loadingPatientData: false,
                patientDataLists: action.payload,
                patientDataCount: action.count,
                patientDataPermissions:action.permissions,
            };

        case "ADD_PATIENTDATA_FULFILLED":
        case "DELETE_PATIENTBASICINFO_FULFILLED":
        case "DELETE_PATIENTPOLICYALERT_FULFILLED":
            return {
                ...state,
                loadingPatientData: false,
                changedPatientDataStatus: action.payload
            };

            case "ADD_PATIENTBASICINFO_FULFILLED":
                return {
                    ...state,
                    loadingPatientData: false,
                    changedPatientDataStatus: action.payload,
                    patientupdated:action.payload?.data?.id  || state.patientupdated,
                    errorsPatientData:{},
                    message: action.payload?.message,
                };
        
        case "UPDATE_PATIENTDATA_FULFILLED":
            return {
                ...state,
                loadingPatientData: false,
                changedPatientDataStatus: action.payload,
                errorsPatientData:{}
            };

        case "UPDATE_PATIENTDATA_STATUS_FULFILLED":
            return {
                ...state,
                loadingPatientData: false,
                changedPatientDataStatus: action.payload,
            };

        case "GET_PATIENTDATA_LISTBYID_FULFILLED":
            return {
                ...state,
                loadingPatientData: false,
               // patientDataLists: action.payload,
                patientDataListID: action.payload,
                errorsPatientData: action.payload
            };

        case "DELETE_PATIENTDATA_FULFILLED":
            return {
                ...state,
                loadingPatientData: false,
                changedPatientDataStatus: action.payload
            };

        case "RESET_DELETE_PATIENTDATA_STATUS":
            return {
                ...state,
                loadingPatientData: false,
                changedPatientDataStatus: [],
                errorsPatientData:{}
            };

        case "RESET_DELETE_PATIENTPOLICYALERT_FULFILLED":
            return {
                ...state,
                loadingPatientData: false,
                changedPatientDataStatus: action.payload
            };

        case "GET_PATIENTDATA_LIST_REJECTED":
        case "ADD_PATIENTDATA_REJECTED":
         case "ADD_PATIENTBASICINFO_REJECTED":
        case "UPDATE_PATIENTDATA_REJECTED":
        case "UPDATE_PATIENTDATA_STATUS_REJECTED":
        case "DELETE_PATIENTDATA_REJECTED":
        case "GET_PATIENTDATA_LISTBYID_REJECTED":
        case "DELETE_PATIENTBASICINFO_REJECTED":
        case "DELETE_PATIENTPOLICYALERT_REJECTED":
            return {
                ...state,
                loadingPatientData: false,
                errorsPatientData: action.payload
            };

        default:
            return state;
    }
}

export default policyDataReducer;